import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-add-item-confirm-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule
  ],
  templateUrl: './add-item-confirm-dialog.component.html',
  styleUrl: './add-item-confirm-dialog.component.scss',
})
export class AddItemConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { itemName: string, newItem: string, similarItems: string[] }) { }

}
